export const environment = {
	production: true,
	isMockEnabled: false, // You have to switch this, when your real back-end is done
	Use_Analytics: true,
	registerKey: "6LftDv0ZAAAAAOGUyiUKHT2pZRF3to09PNa2wOUz",
	authTokenKey: "authce9d77b308c149d5992a80073637e4d5",
	BASE_URL_PROFILE: "/hec-profile-rest/rest/",
	BASE_URL_COMMON: "/hec-common-rest/rest/",
	BASE_URL_DAS: "/hec-das-rest/rest/",
	BASE_URL_DES: "/hec-das-rest/rest/",
	BASE_URL_RPT: "/hec-rpt-rest/rest/",
	BASE_URL_HRD: "/hec-hrd-rest/rest/",
	BASE_URL_COMMON_RGA: "https://research.hec.gov.pk//hec-rnd-rest/rest/",
	BASE_URL_RGMS: "http://10.87.204.242:81/hec-profile-rest/rest/",
	BASE_URL_COMMON_RGMS: "http://10.87.204.242:81//hec-common-rest/rest/",
	BASE_URL_COURSERA: "/startup-1.0/",
	BASE_URL_PCD: "/startup-1.0/",
	JWT: "jwt",

	version: 0.9,
};
